import styled from 'styled-components';

const BigLabel = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.colors.primary2};
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-top: 4px;
`;

export default BigLabel;
